$( document ).ready( function() {

    if ( !$( 'body' ).hasClass( 'page-home' ) ) return;

    const hero = $( '#home--hero' )

    if ( !hero ) return;

    const heroItem = home.hero_items[Math.floor(Math.random()*home.hero_items.length)];

    $( '.hero-inner--content h2', hero ).text( heroItem.content )
    $( '.hero-inner--image > img' ).attr( 'src', heroItem.url ).attr( 'alt', heroItem.alt )

    setTimeout( () => {

        hero.removeAttr( 'style' )

    }, 500 )

} )